module.exports = __webpack_public_path__ + "img/scroll1.0c7b5035.png";